import { useState } from "react";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import UserGuide from "./UserGuide";

export default function HelpGuideWidget() {
  const [showGuide, setShowGuide] = useState(false);

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full bg-background shadow-sm hover:bg-muted"
              onClick={() => setShowGuide(true)}
            >
              <HelpCircle className="h-5 w-5 text-muted-foreground" />
              <span className="sr-only">Help Guide</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p>Open User Guide</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <Dialog open={showGuide} onOpenChange={setShowGuide}>
        <DialogContent className="max-w-4xl p-0">
          <VisuallyHidden>
            <DialogTitle>User Guide</DialogTitle>
          </VisuallyHidden>
          <UserGuide onClose={() => setShowGuide(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
}
